<script lang="ts" setup>

  import type { ProductVariantPickerResource, ProductVariantSimpleResource } from '@storefront/resources';
  import { useHttpClient, useRoute } from '@othercommerce/foundation';

  interface AttributeOption {
    label: string,
    value: number,
  }

  interface Attribute {
    label: string,
    options: AttributeOption[],
    value: number,
  }

  interface Props {
    variant: ProductVariantPickerResource,
    attributes: Attribute[],
    selected: any,
    floatingLabels?: boolean | undefined,
  }

  interface Emits {
    (e: 'selected', variant: ProductVariantSimpleResource): void,
  }

  const emit = defineEmits<Emits>();

  const props = withDefaults(defineProps<Props>(), {
    floatingLabels: true,
  });

  const http = useHttpClient();
  const route = useRoute();

  function onSubmit(data: any) {
    let product = props.variant.productId;
    let params = { product, ...data };

    return http.dispatch('GET', route('web.product.picker.api', params)).then((response) => {
      emit('selected', response.variant);
    });
  }
</script>
<template>
  <div class="variant-attributes">
    <h2 class="variant-attributes__header" id="variant-attributes__header" v-if="$slots.title">
      <slot name="title" />
    </h2>
    <div class="variant-attributes__list">
      <FormController continuous :data="{ selected }" @submit="onSubmit" :aria-labelledby="$slots.title ? 'variant-attributes__header': null ">
        <template v-for="attribute in attributes" :key="attribute.value">
          <SfFormSelect :label="attribute.label" required :floating="floatingLabels" :name="`selected.${attribute.value}`" :options="attribute.options" />
        </template>
      </FormController>
    </div>
  </div>
</template>
<style scoped lang="scss">
  .variant-attributes {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;

    &__header {
      font-size: 1rem;
      font-weight: var(--font-weight-semi);
    }

    &__list {
      display: flex;
      flex-direction: column;
      flex-wrap: wrap;
      gap: 0.5rem;
    }
  }
</style>
